//delete-button.js
class ReflowSVG {

    constructor($http, $compile) {

        return {
            restrict: 'E',
            scope: {
                icon: "@",
                draggable: "=",
                width: "@",
                height: "@"
            },
            link: ($scope, $element, $attr) => {

            var cache = null;
            
            let render = () => {
                
                $element.empty();
                
                var width = $scope.width || 16;
                var height = $scope.height || 16;
    
                if (!/(Edge|Trident)/.test(navigator.userAgent)) {
                    var svg = "<svg viewBox='0 0 512 512' width='" + width + "' height='" + height + "'><use xlink:href='/images/appicons.svg#" + $scope.icon + "'></use></svg>";
                    var el = $(svg);
                    $element.append(el);
                }
                else {
                
                    // can't use '<use xlink:href=...' in IE so have to extract the fragment manually 
                    
                    if(cache == null) {
                        $http.get("/images/appicons.svg").success(function(data) {
                            cache = $(data);
                            buildSvg();
                        });
                    }
                    else {
                        buildSvg();
                    }
                }

                let buildSvg = () => {
                    var fragment = $("#" + $scope.icon, cache);
                    var svg = "<svg viewBox='0 0 512 512' width='" + width + "' height='" + height + "'></svg>";
                    var el = $(svg);
                    el.append(fragment);
                    $element.append(el);
                };   
            };           
            
            if("undefined" != typeof $scope.draggable && $scope.draggable != null) {
                $element.data("asset", $scope.draggable);
                //$element.addClass("asset_library_draggable");
                $element.draggable({revert: "invalid", appendTo: "body", containment: "window", cursor: "crosshair", helper: "clone", opacity: 0.5, zIndex: 4998});
            }
            
            render();
            
            $scope.$watch("icon", function(newval, oldval) {
                if("undefined" !== typeof newval && "undefined" !== typeof oldval && newval != oldval) {
                    render();
                }
            });
            
        }
        };

    }

}


angular.module('cpm')
    .directive('reflowSvg', ['$http', '$compile', ($http, $compile) => {
        'use strict';
        return new ReflowSVG($http, $compile);
    }]);

